import { useContext } from 'react';
import './../../../form.css';
import { Field } from 'formik';
import { Grid, Card, CardContent, CardHeader } from '@material-ui/core';
import { Select, FieldError } from '../../../../common';
import { CustomerRequestContext } from '../../CustomerRequestContext';
import { SapTableNames } from '../../../../../helpers';
import { makeStyles } from '@material-ui/core/styles';
import { decimalNumberField } from '../../../../../helpers/Utils';

const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
}));

export const OrderInfoForm = (props) => {
    const classes = useStyles();

    const {        
        state,
        getTableOptionsWithCode
    } = useContext(CustomerRequestContext);

    return (
        <Card>
            <CardHeader title="Opening order" />
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xl={10} md={12} xs={12}>
                        <Field
                            className={classes.field}
                            name="order.firstBuyValue"
                            variant="outlined"
                            label="Opening order and its term *"
                            disabled={props.disabled}
                            component={decimalNumberField} 
                        />
                        <FieldError name="order.firstBuyValue" errors={state.errors} />
                    </Grid>
                    <Grid item xl={2} md={12} xs={12}>
                        <Select
                            name="order.currencyId"
                            label="Currency *"
                            disabled={props.disabled}
                            options={getTableOptionsWithCode(SapTableNames.Currencies, state.request.dbType)}
                        />
                        <FieldError name="order.currencyId" errors={state.errors} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}